import { faker } from '@faker-js/faker'

import { getGroupedServiceOffer } from './GroupedServiceOfferView'
import { getServiceOffer } from './ServiceOffer'

import { ServiceOfferDetailsView } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getServiceOfferDetailsView = asBuilder((): ServiceOfferDetailsView => {
  return {
    id: faker.number.int(),
    groupId: faker.string.uuid(),
    groupedServiceOffers: [getGroupedServiceOffer()],
    ...getServiceOffer(),
  }
})
